var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDraft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm.525-10.5a.525.525 0 1 0-1.05 0V8c0 .226.145.427.359.498l2.1.7a.525.525 0 1 0 .332-.996l-1.741-.58V4.5Z",
  fill: "#6D727F"
})));
export default SvgDraft;